import { useEffect, useState } from "react";
import { caApi, formatApiError } from "@/company-admin/api";

export function usePath(path, deps = []) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    async function refresh() {
        setLoading(true);
        setError("");
        try {
            const r = await caApi.get(path);
            setData(r.data);
        } catch (e) {
            setError(formatApiError(e));
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return { data, loading, error, refresh, setData };
}

export function CaPageHeader({ title, subtitle, action }) {
    return (
        <div className="flex items-start justify-between gap-4 mb-8">
            <div>
                <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight text-black">{title}</h1>
                {subtitle && <p className="mt-2 text-[14px] text-neutral-600 max-w-2xl">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}

export function friendlyTime(iso) {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        if (isNaN(d)) return iso;
        return d.toLocaleString(undefined, { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
    } catch {
        return iso;
    }
}
